/* eslint-disable consistent-return */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

// Components
import Modal from '../../../../Modal';
import NavBar from '../../../../NavBar';
import Scene from '../../../../Scene';
import Heading from '../../../../Heading';
import Button from '../../../../Button';

// Icons
import GiftIcon from '../../../../../icons/gift.svg';

import styles from './SaucesList.styl';

const cx = classNames.bind(styles);

class SaucesList extends PureComponent {
  onItemClick = sauce => {
    const { onHide, addToCart } = this.props;

    onHide();
    addToCart(sauce.variations[0].id);
  };

  renderNavbar = () => (
    <FormattedMessage id="freeSauces.modal.title">
      {title => <NavBar view="secondary" onBack={this.props.onHide} title={title} />}
    </FormattedMessage>
  );

  render() {
    const { isOpen, className, sauces, disabled } = this.props;

    return (
      <Modal className={cx('SaucesList', className)} direction="left" isOpen={isOpen}>
        <Scene renderNavbar={this.renderNavbar}>
          <ul className={cx('SaucesList__list')}>
            {sauces.map(sauce => {
              const { variations, name, id } = sauce;

              const isInStopList = variations.find(variation => variation.isInStopList);

              return isInStopList ? null : (
                <li
                  className={cx('SaucesList__item')}
                  key={id}
                  onClick={() => (disabled ? false : this.onItemClick(sauce))}
                >
                  <figure className={cx('SaucesList__item-image')}>
                    <img src={variations[0]?.image_cart || ''} alt="" />
                  </figure>
                  <div className={cx('SaucesList__item-info')}>
                    <Heading className={cx('SaucesList__item-name')} level="5" tagName="div">
                      {name}
                    </Heading>
                    <div className={cx('SaucesList__item-description')}>
                      {variations[0].size.value}&nbsp;
                      {variations[0].size.unit}
                    </div>
                  </div>
                  <Button className={cx('SaucesList__item-button')} small>
                    <GiftIcon width={20} height={20} />
                  </Button>
                </li>
              );
            })}
          </ul>
        </Scene>
      </Modal>
    );
  }
}

SaucesList.defaultProps = {
  className: '',
  isOpen: false,
  disabled: false,
};

SaucesList.propTypes = {
  className: PropTypes.string,
  sauces: PropTypes.array.isRequired,
  addToCart: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  disabled: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
};

export default SaucesList;
